import React from 'react';
import { Views } from 'react-big-calendar';
import { CalendarEventsPeriod } from '@trnsact/trnsact-shared-types';

import { Calendar, CalendarConnector, CalendarEventCard } from '../calendar';

export const DayCalendar = () => (
  <CalendarConnector
    period={CalendarEventsPeriod.Day}
    children={props => (
      <Calendar
        step={10}
        timeslots={6}
        view={Views.DAY}
        views={[Views.DAY]}
        components={{
          event: props => <CalendarEventCard showMore {...props} />,
        }}
        {...props}
      />
    )}
  />
);
